<template>
  <button
    class="btn btn-primary btn-copy"
    @click="copyToClipboard"
  >
    <img
      src="/static/images/site/icon-copy.svg"
      alt="Copiar"
    >
    <transition name="fade">
      <span
        v-show="tooltipFeedback"
        :class="[tooltipPosition, { 'tooltip-active': tooltipFeedback }]"
      >Copiado!</span>
    </transition>
  </button>
</template>

<script>
export default {
  name: 'ButtonCopy',
  props: {
    textToCopy: {
      required: true
    },
    position: {
      type: String,
      default: 'top'
    }
  },
  data: () => ({
    tooltipFeedback: false
  }),
  computed: {
    tooltipPosition() {
      return `tooltip-in-${this.position}`
    }
  },
  methods: {
    copyToClipboard() {
      let text = this.textToCopy
      const cb = navigator.clipboard

      if (typeof text === 'object') {
        text = this.textToCopy.join('\r\n')
      }

      if (cb) {
        cb.writeText(text)
      } else {
        window.clipboardData.setData('Text', text)
      }

      this.tooltipFeedback = true

      setTimeout(() => {
        this.tooltipFeedback = false
      }, 600)
    }
  }
}
</script>

<style lang="scss">
.btn-copy {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  opacity: 0;
  transition: opacity ease 0.4s;
  position: relative;
  font-family: 'Exo 2', sans-serif !important;

  span {
    width: 100px !important;
    height: 100%;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #5f5f5f;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
    position: absolute;

    &.tooltip-in-top {
      top: -50px;
      left: -28px;
    }

    &.tooltip-in-left {
      top: -1px;
      left: -109px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
</style>
